import { render, staticRenderFns } from "./CourseItem.vue?vue&type=template&id=39154ecd&scoped=true"
import script from "./CourseItem.vue?vue&type=script&lang=js"
export * from "./CourseItem.vue?vue&type=script&lang=js"
import style0 from "./CourseItem.vue?vue&type=style&index=0&id=39154ecd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39154ecd",
  null
  
)

export default component.exports